export default __webpack_public_path__ + "static/media/askchristee-logo-white.17bc7c93.svg";